"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsFetching = void 0;
const react_query_1 = require("@tanstack/react-query");
exports.useIsFetching = react_query_1.useIsFetching;
